import {
  Box,
  IconButton,
  Typography,
  type TypographyProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1),
  padding: theme.spacing(2, 3),
}));

export const Heading = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const Title = styled(Typography)<TypographyProps>({
  fontWeight: 600,
});

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  marginTop: theme.spacing(-0.75),
  marginRight: theme.spacing(-1),
}));

export const Columns = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(3),

  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const Controls = styled(Box)({
  minWidth: 0,
});

export const Field = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
}));

export const FieldLabel = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));
